// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const inchesToFeetAndInches = (inches) => {
  if (inches) {
    const feet = Math.floor(inches / 12)
    const remainingInches = inches % 12
    return { feet, inches: remainingInches }
  }

  return { feet: null, inches: null }
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const formatHeightValueForAPI = (feet, inches) => Number(feet) * 12 + Number(inches)

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const heightRowGenerator = (inchesFromApi) => {
  if (!inchesFromApi) {
    return '--'
  }
  const { feet, inches } = inchesToFeetAndInches(inchesFromApi)
  // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
  const correctFeet = feet > 0 ? `${feet} ft` : ''
  // @ts-expect-error TS18047 -- MIGRATION: not approved, fix when encountered
  const correctInch = inches > 0 ? `${inches} in` : ''
  const resultRow = `${correctFeet} ${correctInch}`
  return resultRow.trim()
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const weightRowGenerator = (lbsFromApi) => {
  if (!lbsFromApi) {
    return '--'
  }
  return `${lbsFromApi} lbs`
}

const maritalStatusEnum = {
  annulled: 'annulled',
  divorced: 'divorced',
  legallyseparated: 'legallyseparated',
  married: 'married',
  polygamous: 'polygamous',
  nevermarried: 'nevermarried',
  domesticpartner: 'domesticpartner',
  single: 'single',
  widowed: 'widowed',
  prefernottosay: 'prefernottosay',
}
const maritalStatusValueEnum = {
  annulled: 'Annulled',
  divorced: 'Divorced',
  legallyseparated: 'Legally separated',
  married: 'Married',
  polygamous: 'Polygamous',
  nevermarried: 'Never married',
  domesticpartner: 'Domestic partner',
  single: 'Single',
  widowed: 'Widowed',
  prefernottosay: 'Prefer not to say',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMaritalStatusForAPI = (statusRow) => {
  const currentStatusValues = Object.entries(maritalStatusValueEnum).find((valuesArray) => valuesArray[1] === statusRow)
  return currentStatusValues?.[0]
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getMaritalRow = (value) => {
  switch (value) {
    case maritalStatusEnum.annulled:
      return maritalStatusValueEnum.annulled
    case maritalStatusEnum.divorced:
      return maritalStatusValueEnum.divorced
    case maritalStatusEnum.legallyseparated:
      return maritalStatusValueEnum.legallyseparated
    case maritalStatusEnum.married:
      return maritalStatusValueEnum.married
    case maritalStatusEnum.polygamous:
      return maritalStatusValueEnum.polygamous
    case maritalStatusEnum.nevermarried:
      return maritalStatusValueEnum.nevermarried
    case maritalStatusEnum.domesticpartner:
      return maritalStatusValueEnum.domesticpartner
    case maritalStatusEnum.single:
      return maritalStatusValueEnum.single
    case maritalStatusEnum.widowed:
      return maritalStatusValueEnum.widowed
    case maritalStatusEnum.prefernottosay:
      return maritalStatusValueEnum.prefernottosay
    default:
      return '--'
  }
}

const racialStatusEnum = {
  americanindianalaskanative: 'americanindianalaskanative',
  asian: 'asian',
  blackafricanamerican: 'blackafricanamerican',
  caucasian: 'caucasian',
  hispaniclatino: 'hispaniclatino',
  nativehawaiianpacificislander: 'nativehawaiianpacificislander',
  prefernottosay: 'prefernottosay',
}

const racialStatusValueEnum = {
  americanindianalaskanative: 'American Indian or Alaska Native',
  asian: 'Asian',
  blackafricanamerican: 'Black or African American',
  caucasian: 'Caucasian',
  hispaniclatino: 'Hispanic or Latino',
  nativehawaiianpacificislander: 'Native Hawaiian or other Pacific Islander',
  prefernottosay: 'Prefer not to say',
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRacialForAPI = (racialRow) => {
  const currentRacialValues = Object.entries(racialStatusValueEnum).find((valuesArray) => valuesArray[1] === racialRow)
  return currentRacialValues?.[0]
}

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getRacialRow = (value) => {
  switch (value) {
    case racialStatusEnum.americanindianalaskanative:
      return racialStatusValueEnum.americanindianalaskanative
    case racialStatusEnum.asian:
      return racialStatusValueEnum.asian
    case racialStatusEnum.blackafricanamerican:
      return racialStatusValueEnum.blackafricanamerican
    case racialStatusEnum.caucasian:
      return racialStatusValueEnum.caucasian
    case racialStatusEnum.hispaniclatino:
      return racialStatusValueEnum.hispaniclatino
    case racialStatusEnum.nativehawaiianpacificislander:
      return racialStatusValueEnum.nativehawaiianpacificislander
    case racialStatusEnum.prefernottosay:
      return racialStatusValueEnum.prefernottosay
    default:
      return ''
  }
}
export const genderEnum = {
  male: 'male',
  female: 'female',
}
export const genderValueEnum = {
  male: 'Male',
  female: 'Female',
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getGenderRow = (gender) => {
  switch (gender) {
    case genderEnum.male:
      return genderValueEnum.male
    case genderEnum.female:
      return genderValueEnum.female
    default:
      return '--'
  }
}
